import { Loader2 } from "lucide-react";

export function InputPanelSkeleton() {
  return (
    <div className="flex flex-col h-full bg-background relative">
      {/* Animated loading indicator */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="flex flex-col items-center gap-3 bg-background/95 backdrop-blur-sm p-6 rounded-lg border shadow-lg">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p className="text-sm text-muted-foreground font-medium">Loading input data...</p>
        </div>
      </div>
    </div>
  );
}

export function OutputPanelSkeleton() {
  return (
    <div className="flex flex-col h-full bg-background relative">
      {/* Animated loading indicator */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="flex flex-col items-center gap-3 bg-background/95 backdrop-blur-sm p-6 rounded-lg border shadow-lg">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p className="text-sm text-muted-foreground font-medium">Executing...</p>
        </div>
      </div>
    </div>
  );
}

export function PropertyPanelSkeleton() {
  return (
    <div className="flex flex-col h-full bg-background relative">
      {/* Animated loading indicator */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="flex flex-col items-center gap-3 bg-background/95 backdrop-blur-sm p-6 rounded-lg border shadow-lg">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p className="text-sm text-muted-foreground font-medium">Loading properties...</p>
        </div>
      </div>
    </div>
  );
}
